var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFavorites = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 5.2h10.78",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 10.2h10.78",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 15.2h10.78",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.516 6.562a.127.127 0 0 1-.074-.023l-1.005-.715-1.005.715a.127.127 0 0 1-.192-.062.12.12 0 0 1 0-.077l.393-1.14-1.016-.683a.123.123 0 0 1-.049-.138.123.123 0 0 1 .045-.062.127.127 0 0 1 .074-.024H2.94l.378-1.143a.123.123 0 0 1 .046-.062.127.127 0 0 1 .192.062l.378 1.143h1.253c.027 0 .053.008.075.024a.123.123 0 0 1 .044.14.123.123 0 0 1-.048.06l-1.016.684.392 1.14a.12.12 0 0 1-.061.148.127.127 0 0 1-.057.013Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.516 11.562a.126.126 0 0 1-.074-.023l-1.005-.715-1.005.715a.126.126 0 0 1-.192-.062.12.12 0 0 1 0-.077l.393-1.14-1.016-.683a.123.123 0 0 1-.049-.138.123.123 0 0 1 .045-.062.127.127 0 0 1 .074-.024H2.94l.378-1.143a.123.123 0 0 1 .046-.062.127.127 0 0 1 .192.062l.378 1.143h1.253c.027 0 .053.008.075.024a.123.123 0 0 1 .044.14.123.123 0 0 1-.048.06l-1.016.684.392 1.14a.12.12 0 0 1-.061.148.127.127 0 0 1-.057.013Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.516 16.562a.126.126 0 0 1-.074-.023l-1.005-.715-1.005.715a.126.126 0 0 1-.192-.062.12.12 0 0 1 0-.077l.393-1.14-1.016-.683a.12.12 0 0 1-.004-.2.127.127 0 0 1 .074-.024H2.94l.378-1.143a.126.126 0 0 1 .238 0l.378 1.143h1.253c.027 0 .053.008.075.024a.12.12 0 0 1-.003.2l-1.017.684.392 1.14a.12.12 0 0 1-.061.148.127.127 0 0 1-.057.013Z",
    fill: "currentColor"
  })));
};
export { SvgFavorites as ReactComponent };